import React, { useEffect } from 'react';
import { scheduleBookHashScroll } from './utils/bookingNavigation';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import OurStory from './components/OurStory/OurStory';
import Services from './components/Services/Services';
import HowItWorks from './components/HowItWorks/HowItWorks';
import Testimonials from './components/Testimonials/Testimonials';
import FAQ from './components/FAQ/FAQ';
import CalendlySection from './components/CalendlySection/CalendlySection';
import CTABanner from './components/CTABanner/CTABanner';
import Footer from './components/Footer/Footer';
import PersistentCTA from './components/PersistentCTA/PersistentCTA';
import UnderConstructionPage from './components/UnderConstruction/UnderConstructionPage';
import AboutHero from './components/AboutHero/AboutHero';
import AboutStoryIntro from './components/AboutStoryIntro/AboutStoryIntro';
import AboutHowWeWork from './components/AboutHowWeWork/AboutHowWeWork';
import AboutTeam from './components/AboutTeam/AboutTeam';
import ServiceLandscapeHero from './components/ServiceLandscapeHero/ServiceLandscapeHero';
import ServiceLandscapeCustom from './components/ServiceLandscapeCustom/ServiceLandscapeCustom';
import ServiceLandscapeWhy from './components/ServiceLandscapeWhy/ServiceLandscapeWhy';
import ServiceYardCareHero from './components/ServiceYardCareHero/ServiceYardCareHero';
import ServiceYardCareIntro from './components/ServiceYardCareIntro/ServiceYardCareIntro';
import ServiceYardCareSeasons from './components/ServiceYardCareSeasons/ServiceYardCareSeasons';

function App() {
  // Placeholder marker for deployment re-trigger.
  const path = window.location.pathname.toLowerCase();
  const isOurWork = path === '/our-work';
  const isAbout = path === '/about';
  const isLandscapeDesign = path === '/services/landscape-design';
  const isCompleteYardCare = path === '/services/complete-yard-care';
  const isHome =
    !isOurWork && !isAbout && !isLandscapeDesign && !isCompleteYardCare;

  useEffect(() => scheduleBookHashScroll(), [isHome]);

  return (
    <div>
      <Navbar />
      {isOurWork ? (
        <UnderConstructionPage title="Our Work" />
      ) : isLandscapeDesign ? (
        <>
          <ServiceLandscapeHero />
          <ServiceLandscapeCustom />
          <ServiceLandscapeWhy />
          <FAQ serviceTag="DESIGN & INSTALLATION" />
          <CTABanner />
        </>
      ) : isCompleteYardCare ? (
        <>
          <ServiceYardCareHero />
          <ServiceYardCareIntro />
          <ServiceYardCareSeasons />
          <FAQ serviceTag="COMPLETE YARD CARE" />
          <CTABanner />
        </>
      ) : isAbout ? (
        <>
          <AboutHero />
          <AboutStoryIntro />
          <AboutHowWeWork />
          <AboutTeam />
          <CTABanner />
        </>
      ) : (
        <>
          <Hero />
          <OurStory />
          <Services />
          <HowItWorks />
          <CalendlySection />
          <Testimonials />
          <FAQ />
          <CTABanner />
          <PersistentCTA />
        </>
      )}
      <Footer />
    </div>
  );
}

export default App;
